import { useEffect, useCallback } from 'react';
import { loadRecaptchaScript } from '../utils/recaptcha.js';

const TOKEN_TIMEOUT_MS = 120000;
const ACTION = 'acquisition_form_submission';

export function useRecaptcha({ siteKey, enabled }) {
  useEffect(() => {
    if (!enabled || !siteKey) return;

    loadRecaptchaScript(siteKey).catch(() => {});
  }, [siteKey, enabled]);

  const getToken = useCallback(async () => {
    if (!enabled || !siteKey) {
      throw new Error('reCAPTCHA is not enabled');
    }

    const recaptcha = await loadRecaptchaScript(siteKey);

    let timeoutId;
    const timeout = new Promise((_, reject) => {
      timeoutId = setTimeout(() => reject(new Error('reCAPTCHA timed out')), TOKEN_TIMEOUT_MS);
    });

    try {
      const token = await Promise.race([recaptcha.execute(siteKey, { action: ACTION }), timeout]);
      if (!token) {
        throw new Error('reCAPTCHA returned an empty token');
      }
      return token;
    } finally {
      clearTimeout(timeoutId);
    }
  }, [siteKey, enabled]);

  return { getToken };
}
